import { SitesPaginatedQuery } from "./types";

export const SITES_API_PATHS = {
  SITE_USER: (siteId: number, userId: number) =>
    `/sites/${siteId}/users/${userId}`,
  SITES: "/sites",
  SITES_PAGINATED: ({ page, size, isActive }: SitesPaginatedQuery) =>
    `/sites/v2?page=${page}&size=${size}&isActive=${isActive}`,
  SITE: (siteId: number) => `/sites/${siteId}`,
  UPLOAD_SITE_MANAGERS: "/upload",
  DELETE_COLLECTOR: (collectorId: number) => `/collector/${collectorId}/delete`,
  RESET_LEARNING: "/supplies-learnings",
  DELETE_SITE: (siteId: number) => `/sites/disable/${siteId}`,
  ESTIMATES: "/estimates",
  DEACTIVATE_ESTIMATES: (estimateId: number) =>
    `/estimates/deactivate/${estimateId}`,
  DELETE_ESTIMATE: (id: number) => `/estimates/${id}`,
  DEACTIVATEDLIST_ESTIMATES: (siteId: number) =>
    `estimates/de-activated/${siteId}`,
  GETREGION: (data: any) => `/sites/getRegion/${data.country}/${data.zipCode}`,
  EXPORT_SITES_DATA: "/sites/export/download",
};

export const RENEWABLE_ENERGY_PURCHASES_API_PATHS = {
  RENEWABLE_ENERGY_PURCHASES: "/renewable-energy-purchase",
  EXPORT_RENEWABLE_ENERGY_PURCHASES: "/renewable-energy-purchase/export",
  GET_RENEWABLE_ENERGY_PURCHASE_BY_ID: (id: number) =>
    `/renewable-energy-purchase/${id}`,
  DELETE_RENEWABLE_ENERGY_PURCHASE: (purchaseId: number) =>
    `/renewable-energy-purchase/${purchaseId}`,
  UPDATE_RENEWABLE_ENERGY_PURCHASE_DISTRIBUTIONS: (id: number) =>
    `/renewable-energy-purchase/${id}/distributions`,
  DELETE_RENEWABLE_ENERGY_PURCHASE_DOCUMENT: (purchaseId: number) =>
    `/renewable-energy-purchase/${purchaseId}/document`,
};
export const INTENSITY_API_PATHS = {
  INTENSITY: "/intensitydata/company",
  UPLOAD_INTENSITY: "/upload",
  DELETE_COMPANYLEVEL: (companyId: number) =>
    `/intensitydata/company/${companyId}`,
};

export const INTENSITYSITE_API_PATHS = {
  INTENSITYSITE: "intensitydata/site",
  UPLOAD_INTENSITY: "/upload",
  DELETE_SITELEVEL: (siteId: number) => `/intensitydata/site/${siteId}`,
};
